// TYPE OF USERS
export const ADMIN = "admin";
export const USER = "user";

export const SALE_REP = "dsr";
export const RETAILER = "retailer";
export const PROMOTER = "promoter";
